<glxy-form-field class="phone-filter-form" [bottomSpacing]="'none'" [formGroup]="phoneFormGroup">
  <glxy-form-row>
    <glxy-form-field
      class="col-xs-3 col-sm-2 phone-filter-country"
      [attr.data-testid]="'phone-country-search-' + _fieldId"
    >
      <mat-select formControlName="country" [placeholder]="'MODEL_DRIVEN_FORM.PHONE.COUNTRY_LABEL' | translate">
        <mat-select-trigger>
          <p
            *ngIf="selectedCountry() as selectedCountry; else invalidCountryTrigger"
            [attr.aria-label]="selectedCountry.countryName"
          >
            {{ selectedCountry.flag }}
          </p>
        </mat-select-trigger>
        <!-- if this ever happens something is wrong -->
        <ng-template #invalidCountryTrigger>Invalid</ng-template>
        <mat-option>
          <ngx-mat-select-search
            [placeholderLabel]="'MODEL_DRIVEN_FORM.PHONE.SEARCH_COUNTRY_LABEL' | translate"
            [noEntriesFoundLabel]="'MODEL_DRIVEN_FORM.PHONE.SEARCH_COUNTRY_NO_RESULTS' | translate"
            [formControl]="searchCountryControl"
          ></ngx-mat-select-search>
        </mat-option>
        <mat-option
          class="phone-filter-country-option"
          *ngFor="let option of filteredCountryOptions$ | async"
          [value]="option.countryCode"
        >
          <span class="phone-filter-country-option-calling-code">{{ option.callingCode }}</span>
          <span class="phone-filter-country-option-display">({{ option.flag }} {{ option.countryName }})</span>
        </mat-option>
      </mat-select>

      <!-- only set error so that extension field gets invalid styling -->
      <glxy-error *ngIf="phoneFormGroup.hasError('invalidPhoneNumber')"></glxy-error>
    </glxy-form-field>
    <glxy-form-field class="col-xs-9 col-sm-7 phone-filter" [attr.data-testid]="'phone-number-search-id-' + _fieldId">
      <span class="phone-filter-code-prefix" matPrefix>{{ selectedCountryCallingCode() }}</span>
      <input
        matInput
        [placeholder]="'GALAXY.FILTER.CHIP.SELECT_EXPRESSION_PLACEHOLDER' | translate"
        formControlName="phoneNumber"
        [attr.autocomplete]="disableAutoComplete"
        digitOnly
        type="tel"
        [matAutocomplete]="auto"
        (keydown.enter)="$event.preventDefault()"
      />
      <!-- only set error so that extension field gets invalid styling -->
      <glxy-error *ngIf="phoneFormGroup.hasError('invalidPhoneNumber')"></glxy-error>
    </glxy-form-field>
    <glxy-form-field
      class="col-xs-12 col-sm-3 phone-filter-extension"
      [attr.data-testid]="'phone-extension-search-id-' + _fieldId"
      [bottomSpacing]="'none'"
    >
      <input
        matInput
        formControlName="extension"
        [placeholder]="'MODEL_DRIVEN_FORM.PHONE.EXTENSION_LABEL' | translate"
        [attr.autocomplete]="disableAutoComplete"
        digitOnly
        type="tel"
        (keydown.enter)="$event.preventDefault()"
      />
      <!-- only set error so that extension field gets invalid styling -->
      <glxy-error *ngIf="phoneFormGroup.hasError('invalidPhoneNumber')"></glxy-error>
    </glxy-form-field>
  </glxy-form-row>
  <mat-autocomplete #auto="matAutocomplete">
    <mat-option *ngFor="let option of filteredOptions()" [value]="option">
      {{ option }}
    </mat-option>
  </mat-autocomplete>
</glxy-form-field>
